export default __webpack_public_path__ + "static/media/Swimming Complex, Ambala4.ad4e0efc.jpg";